import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDURgL2J2M2aHYZZs3ukbPgLmgFCgY9R-E",
  authDomain: "eyesight-optical.firebaseapp.com",
  projectId: "eyesight-optical",
  storageBucket: "eyesight-optical.firebasestorage.app",
  messagingSenderId: "752410837686",
  appId: "1:752410837686:web:60ba2fe1e7724ef9711c17"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
